var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnlock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 34,
    viewBox: "0 0 28 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.13281 17.1655C1.13281 14.7175 3.15803 12.7329 5.65627 12.7329H22.7427C25.2409 12.7329 27.2661 14.7175 27.2661 17.1655V28.567C27.2661 31.015 25.2409 32.9996 22.7427 32.9996H5.65627C3.15803 32.9996 1.13281 31.015 1.13281 28.567V17.1655ZM5.65627 13.8411C3.78259 13.8411 2.26368 15.3295 2.26368 17.1655V28.567C2.26368 30.403 3.78259 31.8914 5.65627 31.8914H22.7427C24.6164 31.8914 26.1353 30.403 26.1353 28.567V17.1655C26.1353 15.3295 24.6164 13.8411 22.7427 13.8411H5.65627Z",
    fill: "#F59D0E",
    stroke: "#F59D0E",
    strokeWidth: 0.9
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2003 19.1927C12.9956 19.1927 12.0191 20.206 12.0191 21.4559C12.0191 22.3119 12.4768 23.0577 13.1548 23.4428L13.4369 23.6031V26.2815C13.4369 26.7189 13.7786 27.0735 14.2002 27.0735C14.6218 27.0735 14.9635 26.7189 14.9635 26.2815V23.6075L15.2925 23.4155C15.9448 23.023 16.3815 22.292 16.3815 21.4559C16.3815 20.206 15.4049 19.1927 14.2003 19.1927ZM10.9336 21.4559C10.9336 19.5839 12.3961 18.0664 14.2003 18.0664C16.0044 18.0664 17.4669 19.5839 17.4669 21.4559C17.4669 22.6166 16.9045 23.6403 16.049 24.2507V26.2815C16.049 27.3409 15.2213 28.1997 14.2002 28.1997C13.1792 28.1997 12.3514 27.3409 12.3514 26.2815V24.2506C11.4959 23.6402 10.9336 22.6165 10.9336 21.4559Z",
    fill: "#F59D0E",
    stroke: "#F59D0E",
    strokeWidth: 0.9
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2013 2.09296C11.2092 2.09296 8.7837 4.469 8.7837 7.4V13.2535C8.7837 13.5553 8.53394 13.8 8.22583 13.8C7.91773 13.8 7.66797 13.5553 7.66797 13.2535V7.4C7.66797 3.86538 10.593 1 14.2013 1C17.8096 1 20.7346 3.86538 20.7346 7.4C20.7346 7.70181 20.4849 7.94648 20.1768 7.94648C19.8687 7.94648 19.6189 7.70181 19.6189 7.4C19.6189 4.469 17.1934 2.09296 14.2013 2.09296Z",
    fill: "#F59D0E",
    stroke: "#F59D0E",
    strokeWidth: 0.9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlock);
export default __webpack_public_path__ + "static/media/Unlock.66989b9420138dbad886b89bfb8ef4fa.svg";
export { ForwardRef as ReactComponent };